import React, { useState, useEffect } from "react";
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import YourLogo from "../../Assets/images/Pro_Logo.png";
import { MdOutlineInventory2 } from "react-icons/md";
import { FaUncharted } from "react-icons/fa";
import { LuLayoutDashboard } from "react-icons/lu";
import "../../Assets/styles/style.css"
import "./sideBarStyle.css"
import { RxHamburgerMenu } from "react-icons/rx";
import { LuFileCog } from "react-icons/lu";
import { useSelector } from "react-redux";
import { getCompany } from "../../../Redux/selecters";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { FiSearch, FiX } from "react-icons/fi";

const InventorySideBar = () => {
  const location = useLocation();

  // Update browser tab title whenever the active Inventory route changes.
  useEffect(() => {
    const path = location.pathname.toLowerCase();

    const routeTitles = [
      { match: "/inventory/master/item", title: "Item Master" },
      { match: "/inventory/master/unitmeasurement", title: "UOM Master" },
      { match: "/inventory/master/category", title: "Category" },
      { match: "/inventory/master/subcategory", title: "SubCategory" },
      { match: "/inventory/master/department", title: "Department" },
      { match: "/inventory/master/stock", title: "Stock Type" },
      { match: "/inventory/master/packing", title: "Packing Type" },
      { match: "/inventory/master/location/categorymaster", title: "Location Category Master" },
      { match: "/inventory/master/locationmaster", title: "Location Master" },
      { match: "/inventory/master/company", title: "Company Master" },
      { match: "/inventory/master/branch", title: "Branch Master" },
      { match: "/inventory/master/currency", title: "Currency Master" },
      { match: "/inventory/master/payment", title: "Payment Master" },
      { match: "/inventory/master/bank", title: "Bank Master" },
      { match: "/inventory/master/supplier_type", title: "Supplier Type" },
      { match: "/inventory/requisition", title: "Purchase Requisition" },
      { match: "/inventory/pricecomparison", title: "Price Comparison" },
      { match: "/inventory/purchase", title: "Purchase Order" },
      { match: "/inventory/purchaseorder", title: "Purchase Order" },
      { match: "/inventory/grn", title: "GRN" },
      { match: "/inventory/invoice", title: "Invoice" },
      { match: "/inventory/purchasereturn", title: "Purchase Return" },
      { match: "/inventory/directpurchase", title: "Direct Purchase" },
      { match: "/inventory/approvaluser", title: "Approval User" },
      { match: "/inventory/approval", title: "Approval" },
      { match: "/inventory/stocktake", title: "Stock Take" },
      { match: "/inventory/posting", title: "Posting" },
      { match: "/inventory/userstore", title: "User Store Request" },
      { match: "/inventory/issueitems", title: "Item Issue" },
      { match: "/inventory/stock/adjustment", title: "Stock Adjustment" },
      { match: "/inventory/issue/direct", title: "Issue Inventory Direct" },
      { match: "/inventory/issue/return", title: "Issue Return" },
      { match: "/inventory/issue/received", title: "Receiving Confirmation" },
      { match: "/inventory/partial", title: "PO Cancellation/Closing" },
      { match: "/inventory/reports/items", title: "Stock Report" },
      { match: "/inventory/reports/purchaseorder", title: "Purchase Order Report" },
      { match: "/inventory/reports/purchaserequisition", title: "Requisition Report" },
      { match: "/inventory/reports/grn", title: "GRN Report" },
      { match: "/inventory/reports/purchasereturn", title: "Purchase Return Report" },
      { match: "/inventory/reports/invoice", title: "Invoice Report" },
      { match: "/inventory/reports/storetransection", title: "Stock Transaction Report" },
      { match: "/inventory/reports/stockvarience", title: "Stock Take Varience Report" },
      { match: "/inventory/reports/issuecosting", title: "Issue Based Costing Report" },
      { match: "/inventory/reports/poanalysis", title: "PO Analysis Report" },
      { match: "/inventory/reports/materialraceived", title: "Material Received Report" },
      { match: "/inventory/reports/materialconsumption", title: "Material Consumption Report" },
      { match: "/inventory/reports/poitemwise", title: "PO Item Wise Report" },
      { match: "/inventory/reports/stockmovement", title: "Stock Movement Report" },
      { match: "/inventory/reports/lease", title: "Lease Report" },
      { match: "/inventory/dashboard", title: "Dashboard" },
    ];

    const activeRoute = routeTitles.find(({ match }) =>
      path === match || path.startsWith(`${match}/`)
    );

    document.title = activeRoute
      ? `${activeRoute.title} | Pro360`
      : "Pro360";
  }, [location.pathname]);
  const [collapsed, setCollapsed] = useState(false);
  const [showMasterSegment, setMasterSegment] = useState(false);
  const [showTransectionSegment, setTransectionSegment] = useState(false);
  const [showReportSegment, setReportSegment] = useState(false);
  const companies = useSelector(getCompany);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const isSearching = searchTerm.trim().length > 0;

  // master
  const itemMasters = location.pathname === '/Inventory/Master/Item' || location.pathname === '/Inventory/Master/Item/Create';
  const catMasters = location.pathname.startsWith('/Inventory/Master/category');
  const subCatMasters = location.pathname.startsWith('/Inventory/Master/SubCategory');
  const UomMasters = location.pathname.startsWith('/Inventory/Master/UnitMeasurement');
  const DepMasters = location.pathname.startsWith('/Inventory/Master/Department');
  const StockMasters = location.pathname.startsWith('/Inventory/Master/Stock');
  const packingMasters = location.pathname.startsWith('/Inventory/Master/Packing');
  const companyMasters = location.pathname.startsWith('/Inventory/Master/Company');
  const branchMaster = location.pathname.startsWith('/Inventory/Master/Branch');
  const currencyMaster = location.pathname.startsWith('/Inventory/Master/Currency');
  const paymentMaster = location.pathname.startsWith('/Inventory/Master/Payment');
  const bankMaster = location.pathname.startsWith('/Inventory/Master/Bank');
  const supplierMaster = location.pathname.startsWith('/Inventory/Master/supplier_Type');
  const locationMaster = location.pathname.startsWith('/Inventory/Master/LocationMaster');
  const locationCategoryMaster = location.pathname.startsWith('/Inventory/Master/Location/CategoryMaster');
  // transection
  const PrMaster = location.pathname.startsWith('/Inventory/Requisition/');
  const PcMaster = location.pathname.startsWith('/Inventory/PriceComparison/');
  const PoMaster = location.pathname.startsWith('/Inventory/Purchase/') || location.pathname.startsWith('/Inventory/PurchaseOrder/');
  const PoMasterk = location.pathname.startsWith('/Inventory/Purchase/K');
  const Grn = location.pathname.startsWith('/Inventory/GRN/');
  const invoice = location.pathname.startsWith('/Inventory/invoice/');
  const PReturn = location.pathname.startsWith('/Inventory/PurchaseReturn/');
  const DirectPurchase = location.pathname.startsWith('/Inventory/DirectPurchase/');
  const approval = location.pathname === ('/Inventory/Approval');
  const approvalUser = location.pathname.startsWith('/Inventory/ApprovalUser');
  const stockTake = location.pathname.startsWith('/Inventory/StockTake');
  const posting = location.pathname.startsWith('/Inventory/Posting');
  const userStore = location.pathname.startsWith('/Inventory/UserStore/');
  const issueItem = location.pathname.startsWith('/Inventory/IssueItems/');
  const stockAdjustment = location.pathname.startsWith('/Inventory/Stock/Adjustment');
  const IssueReceived = location.pathname.startsWith('/Inventory/Issue/Received');
  const Partial = location.pathname.startsWith('/Inventory/Partial');
  const issuereturn = location.pathname.startsWith('/Inventory/Issue/Return');
  const issueDirect = location.pathname.startsWith('/Inventory/Issue/Direct');
  const itemReport = location.pathname.startsWith('/Inventory/Reports/Items');
  const RequsitionReport = location.pathname.startsWith('/Inventory/Reports/PurchaseRequisition');
  const POreport = location.pathname.startsWith('/Inventory/Reports/PurchaseOrder');
  const GRNRep = location.pathname.startsWith('/Inventory/Reports/grn');
  const PRRep = location.pathname.startsWith('/Inventory/Reports/PurchaseReturn');
  const InvRep = location.pathname.startsWith('/Inventory/Reports/Invoice');
  const StockRep = location.pathname.startsWith('/Inventory/Reports/storeTransection');
  const StockVarRep = location.pathname.startsWith('/Inventory/Reports/stockVarience');
  const POAnalysis = location.pathname.startsWith('/Inventory/Reports/POAnalysis');
  const materialRaceived = location.pathname.startsWith('/Inventory/Reports/materialRaceived');
  const materialConsumption = location.pathname.startsWith('/Inventory/Reports/materialConsumption');
  const POItemWise = location.pathname.startsWith('/Inventory/Reports/POItemWise');
  const StockMovement = location.pathname.startsWith('/Inventory/Reports/StockMovement');

  const lease = location.pathname.startsWith('/Inventory/Reports/Lease');
  const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
  const accessibleForms = storedPermissions.filter((form) => form.canView);
  const [permissions, setPermission] = useState(accessibleForms);
  const isVisible = (formName) => {
    const hasPermission = permissions?.some(
      (permission) =>
        permission.formName === formName &&
        permission.canView
    );

    if (!hasPermission) return false;

    if (!isSearching) return true;

    return formName
      .toLowerCase()
      .includes(searchTerm.trim().toLowerCase());
  };
  const handleToggle = () => {
    setCollapsed(!collapsed);
  };
  const masterFormNames = [
    "Item Master",
    "UOM Master",
    "Category",
    "SubCategory",
    "Department",
    "Stock Type",
    "Packing Type",
    "Location Master",
    "Location Category Master"
  ];

  const transactionFormNames = [
    "Purchase Requisition",
    "Price Comparison",
    "Purchase Order",
    "Purchase_Order_K",
    "GRN",
    "Invoice",
    "Purchase Return",
    "Direct Purchase",
    "Approval",
    "Approval User",
    "Stock Take",
    "Posting",
    "User Store Request",
    "Item Issue",
    "Stock Adjustment",
    "Issue Inventory Direct",
    "Issue Return",
    "Issue Received",
    "PO Cancellation"
  ];

  const reportFormNames = [
    "Items",
    "Purchase Order",
    "Requisition",
    "GRN",
    "Purchase Return",
    "Invoice Report",
    "Stock Transection Report",
    "Stock Varience Report",
    "Issue Based Costing",
    "PO Analysis",
    "Material Received",
    "Material Consumption",
    "PO Item Wise Report",
    "Stock Movement"
  ];

  const hasMasterMatch = masterFormNames.some(name => isVisible(name));

  const hasTransactionMatch = transactionFormNames.some(name => isVisible(name));

  const hasReportMatch = reportFormNames.some(name => isVisible(name));
  return (
    <div>
      <ProSidebar collapsed={collapsed}>
        {collapsed ? (
          <a href="/" className="navbar-brand start">
            {/* <img
              src={companies?.selectedCompany?.logo || YourLogo}
              alt="Logo"
              style={{ height: "40px", paddingTop: "8px", paddingBottom: "8px" }}
            /> */}
          </a>
        ) : (
          <a href="/" className="navbar-brand start">
            <img src={companies?.selectedCompany?.logo || YourLogo} alt="Logo" style={{ height: '75px' }} />
            {/* <span className="logoName" style={{ marginLeft: "8px" }}>
              {companies?.selectedCompany?.logo
                ?.split('/')
                .pop()
                ?.split('.')
                .slice(0, -1)
                .join('.')
                ?.charAt(0)
                .toUpperCase() +
                companies?.selectedCompany?.logo
                  ?.split('/')
                  .pop()
                  ?.split('.')
                  .slice(0, -1)
                  .join('.')
                  ?.slice(1)
                  .toLowerCase()}
            </span> */}
          </a>
        )}
        {!collapsed && (
          <div className="sidebar-search">
            <FiSearch size={16} className="sidebar-search-icon" />

            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {isSearching && (
              <FiX
                size={16}
                className="sidebar-search-clear"
                onClick={() => setSearchTerm("")}
              />
            )}
          </div>
        )}

        <Menu className="mt-2">
          {permissions?.some(permission => permission.formName === "Dashboard" && permission.canView) && (
            <MenuItem
              icon={<LuLayoutDashboard size={25} />}
              active={location.pathname.startsWith('/Inventory/Dashboard')}
            >
              <NavLink to="/Inventory/Dashboard">
                <div>Dashboard</div>
              </NavLink>
            </MenuItem>
          )}
          {permissions?.some(
            permission =>
              permission.formName === "Masters" &&
              permission.canView
          ) && (
              <SubMenu
                title="Masters"
                icon={<LuFileCog size={25} />}
                active={location.pathname.startsWith('/Inventory/Master/')}

                open={
                  isSearching
                    ? (
                      isVisible("Item Master") ||
                      isVisible("UOM Master") ||
                      isVisible("Category") ||
                      isVisible("SubCategory") ||
                      isVisible("Department") ||
                      isVisible("Stock Type") ||
                      isVisible("Packing Type") ||
                      isVisible("Location Master") ||
                      isVisible("Location Category Master")
                    )
                    : showMasterSegment
                }

                onOpenChange={(open) => setMasterSegment(open)}
              >
                {isVisible("Item Master") && (
                  <MenuItem><NavLink to="/Inventory/Master/Item" className="mt-2"><div className={`submenu ${itemMasters ? 'subactive' : ''}`}>- Item Master</div></NavLink></MenuItem>
                )}
                {isVisible("UOM Master") && (
                  <MenuItem><NavLink to="/Inventory/Master/UnitMeasurement" className="mt-2"><div className={`submenu ${UomMasters ? 'subactive' : ''}`}>-  UOM Master</div></NavLink></MenuItem>
                )}
                {isVisible("Category") && (
                  <MenuItem><NavLink to="/Inventory/Master/category" className="mt-2"><div className={`submenu ${catMasters ? 'subactive' : ''}`}>- Category</div></NavLink></MenuItem>
                )}
                {isVisible("SubCategory") && (
                  <MenuItem><NavLink to="/Inventory/Master/SubCategory"><div className={`submenu ${subCatMasters ? 'subactive' : ''}`}>- SubCategory</div></NavLink></MenuItem>
                )}
                {isVisible("Department") && (
                  <MenuItem><NavLink to="/Inventory/Master/Department"><div className={`submenu ${DepMasters ? 'subactive' : ''}`}> - Department</div></NavLink></MenuItem>
                )}
                {isVisible("Stock Type") && (
                  <MenuItem><NavLink to="/Inventory/Master/Stock"><div className={`submenu ${StockMasters ? 'subactive' : ''}`}>- Stock Type</div></NavLink></MenuItem>
                )}
                {isVisible("Packing Type") && (
                  <MenuItem><NavLink to="/Inventory/Master/Packing"><div className={`submenu ${packingMasters ? 'subactive' : ''}`}> - Packing Type</div></NavLink></MenuItem>
                )}
                {isVisible("Location Master") && (
                  <MenuItem><NavLink to="/Inventory/Master/LocationMaster"><div className={`submenu ${locationMaster ? 'subactive' : ''}`}>- Location Master</div></NavLink></MenuItem>
                )}
                {isVisible("Location Category Master") && (
                  <MenuItem><NavLink to="/Inventory/Master/Location/CategoryMaster"><div className={`submenu ${locationCategoryMaster ? 'subactive' : ''}`}>- Location Category Master</div></NavLink></MenuItem>
                )}
              </SubMenu>
            )}
          {(!isSearching || hasTransactionMatch) &&
            permissions?.some(
              permission =>
                permission.formName === "Transaction" &&
                permission.canView
            ) && (
              <SubMenu
                className="mt-2"
                title="Transaction"
                icon={<MdOutlineInventory2 size={25} />}
                active={location.pathname.startsWith('/Inventory/')}
                open={
                  isSearching
                    ? hasTransactionMatch
                    : showTransectionSegment
                }
                onOpenChange={(open) => setTransectionSegment(open)}
              >
                {isVisible("Purchase Requisition") && (
                  <MenuItem><NavLink to="/Inventory/Requisition/Listing"><div className={`submenu ${PrMaster ? 'subactive' : ''}`}>- Purchase Requisition</div></NavLink></MenuItem>
                )}
                {isVisible("Price Comparison") && (
                  <MenuItem><NavLink to="/Inventory/PriceComparison/List"><div className={`submenu ${PcMaster ? 'subactive' : ''}`}>- Price Comparison</div></NavLink></MenuItem>
                )}
                {isVisible("Purchase Order") && (
                  <MenuItem><NavLink to="/Inventory/Purchase/K"><div className={`submenu ${PoMaster ? 'subactive' : ''}`}>- Purchase Order</div></NavLink></MenuItem>
                )}
                {isVisible("Purchase Order K") && (
                  <MenuItem><NavLink to="/Inventory/Purchase/K"><div className={`submenu ${PoMasterk ? 'subactive' : ''}`}>- Purchase Order K</div></NavLink></MenuItem>
                )}
                {isVisible("GRN") && (
                  <MenuItem><NavLink to="/Inventory/GRN/Listing"><div className={`submenu ${Grn ? 'subactive' : ''}`}>- GRN</div></NavLink></MenuItem>
                )}
                {isVisible("Invoice") && (
                  <MenuItem><NavLink to="/Inventory/invoice/List"><div className={`submenu ${invoice ? 'subactive' : ''}`}>- Invoice</div></NavLink></MenuItem>
                )}
                {isVisible("Purchase Return") && (
                  <MenuItem><NavLink to="/Inventory/PurchaseReturn/List"><div className={`submenu ${PReturn ? 'subactive' : ''}`}>- Purchase Return</div></NavLink></MenuItem>
                )}
                {isVisible("Direct Purchase") && (
                  <MenuItem><NavLink to="/Inventory/DirectPurchase/List"><div className={`submenu ${DirectPurchase ? 'subactive' : ''}`}>- Direct Purchase</div></NavLink></MenuItem>
                )}
                {isVisible("Approval") && (
                  <MenuItem><NavLink to="/Inventory/Approval"><div className={`submenu ${approval ? 'subactive' : ''}`}>- Approval</div></NavLink></MenuItem>
                )}
                {isVisible("Approval User") && (
                  <MenuItem><NavLink to="/Inventory/ApprovalUser/List"><div className={`submenu ${approvalUser ? 'subactive' : ''}`}>- Approval User</div></NavLink></MenuItem>
                )}
                {isVisible("Stock Take") && (
                  <MenuItem><NavLink to="/Inventory/StockTake"><div className={`submenu ${stockTake ? 'subactive' : ''}`}>- Stock Take</div></NavLink></MenuItem>
                )}
                {isVisible("Posting") && (
                  <MenuItem><NavLink to="/Inventory/Posting"><div className={`submenu ${posting ? 'subactive' : ''}`}>- Posting</div></NavLink></MenuItem>
                )}
                {isVisible("User Store Request") && (
                  <MenuItem><NavLink to="/Inventory/UserStore/List"><div className={`submenu ${userStore ? 'subactive' : ''}`}>- User Store Request</div></NavLink></MenuItem>
                )}
                {isVisible("Item Issue") && (
                  <MenuItem><NavLink to="/Inventory/IssueItems/List"><div className={`submenu ${issueItem ? 'subactive' : ''}`}>- Item Issue</div></NavLink></MenuItem>
                )}
                {isVisible("Stock Adjustment") && (
                  <MenuItem><NavLink to="/Inventory/Stock/Adjustment"><div className={`submenu ${stockAdjustment ? 'subactive' : ''}`}>- Stock Adjustment</div></NavLink></MenuItem>
                )}
                {isVisible("Issue Inventory Direct") && (
                  <MenuItem><NavLink to="/Inventory/Issue/Direct"><div className={`submenu ${issueDirect ? 'subactive' : ''}`}>- Issue Inventory Direct</div></NavLink></MenuItem>
                )}
                {isVisible("Issue Return") && (
                  <MenuItem><NavLink to="/Inventory/Issue/Return"><div className={`submenu ${issuereturn ? 'subactive' : ''}`}>- Issue Return</div></NavLink></MenuItem>
                )}
                {isVisible("Issue Received") && (
                  <MenuItem><NavLink to="/Inventory/Issue/Received"><div className={`submenu ${IssueReceived ? 'subactive' : ''}`}>- Receiving Confirmation</div></NavLink></MenuItem>
                )}
                {isVisible("PO Cancellation") && (
                  <MenuItem><NavLink to="/Inventory/Partial"><div className={`submenu ${Partial ? 'subactive' : ''}`}>- PO Cancellation/Closing</div></NavLink></MenuItem>
                )}
              </SubMenu>
            )}
          {(!isSearching || hasReportMatch) &&
            permissions?.some(
              permission =>
                permission.formName === "Reports" &&
                permission.canView
            ) && (
              <SubMenu
                className="mt-2"
                title="Reports"
                icon={<FaUncharted size={25} />}
                open={
                  isSearching
                    ? hasReportMatch
                    : showReportSegment
                }
                onOpenChange={(open) => setReportSegment(open)}
              >
                {isVisible("Items") && (
                  <MenuItem><NavLink to="/Inventory/Reports/Items"><div className={`submenu ${itemReport ? 'subactive' : ''}`}>- Stock Report</div></NavLink></MenuItem>
                )}
                {isVisible("Purchase Order") && (
                  <MenuItem><NavLink to="/Inventory/Reports/PurchaseOrder"><div className={`submenu ${POreport ? 'subactive' : ''}`}>- Purchase Order Report</div></NavLink></MenuItem>
                )}
                {isVisible("Requisition") && (
                  <MenuItem><NavLink to="/Inventory/Reports/PurchaseRequisition"><div className={`submenu ${RequsitionReport ? 'subactive' : ''}`}>- Requisition Report</div></NavLink></MenuItem>
                )}
                {isVisible("GRN") && (
                  <MenuItem><NavLink to="/Inventory/Reports/grn"><div className={`submenu ${GRNRep ? 'subactive' : ''}`}>- GRN Report</div></NavLink></MenuItem>
                )}
                {isVisible("Purchase Return") && (
                  <MenuItem><NavLink to="/Inventory/Reports/PurchaseReturn"><div className={`submenu ${PRRep ? 'subactive' : ''}`}>- Purchase Return Report</div></NavLink></MenuItem>
                )}
                {isVisible("Invoice Report") && (
                  <MenuItem><NavLink to="/Inventory/Reports/Invoice"><div className={`submenu ${InvRep ? 'subactive' : ''}`}>- Invoice Report</div></NavLink></MenuItem>
                )}
                {isVisible("Stock Transaction Report") && (
                  <MenuItem><NavLink to="/Inventory/Reports/StockTransection"><div className={`submenu ${StockRep ? 'subactive' : ''}`}>- Stock Transaction Report</div></NavLink></MenuItem>
                )}
                {isVisible("Stock Varience Report") && (
                  <MenuItem><NavLink to="/Inventory/Reports/stockVarience"><div className={`submenu ${StockVarRep ? 'subactive' : ''}`}>- Stock Take Varience Report</div></NavLink></MenuItem>
                )}
                {isVisible("Issue Based Costing") && (
                  <MenuItem><NavLink to="/Inventory/Reports/IssueCosting"><div className={`submenu ${StockVarRep ? 'subactive' : ''}`}>- Issue Based Costing Report</div></NavLink></MenuItem>
                )}
                {isVisible("PO Analysis") && (
                  <MenuItem><NavLink to="/Inventory/Reports/POAnalysis"><div className={`submenu ${POAnalysis ? 'subactive' : ''}`}>- PO Analysis Report</div></NavLink></MenuItem>
                )}
                {isVisible("Material Received") && (
                  <MenuItem><NavLink to="/Inventory/Reports/materialRaceived"><div className={`submenu ${materialRaceived ? 'subactive' : ''}`}>- Material Received Report</div></NavLink></MenuItem>
                )}
                {isVisible("Material Consumption") && (
                  <MenuItem><NavLink to="/Inventory/Reports/materialConsumption"><div className={`submenu ${materialConsumption ? 'subactive' : ''}`}>- Material Consumption Report</div></NavLink></MenuItem>
                )}
                {isVisible("PO Item Wise Report") && (
                  <MenuItem><NavLink to="/Inventory/Reports/POItemWise"><div className={`submenu ${POItemWise ? 'subactive' : ''}`}>- PO Item Wise Report</div></NavLink></MenuItem>
                )}
                {isVisible("Stock Movement") && (
                  <MenuItem><NavLink to="/Inventory/Reports/StockMovement"><div className={`submenu ${StockMovement ? 'subactive' : ''}`}>- Stock Movement Report</div></NavLink></MenuItem>
                )}

              </SubMenu>
            )}
        </Menu>

        <div onClick={handleToggle} className="sidebar-toggle-btn" style={{ left: collapsed ? '120px' : '380px' }}>
          <RxHamburgerMenu size={32} />
        </div>
      </ProSidebar>
    </div>
  );
};

export default InventorySideBar;

